import React from "react";
import { useTranslation } from "react-i18next";

// No se muestra si la interfaz no tiene nodos de filtro (contrato §2.2, pantalla 17-B).
// `className` (OTT-2011): clase extra para variantes de otras páginas (la Agenda), sin cambiar
// el botón del buscador.
const FilterButton = ({ activeCount = 0, open, onClick, hasFilters, className = "" }) => {
  const { t } = useTranslation();
  if (!hasFilters) return null;

  return (
    <button
      type="button"
      className={`bq-filter-btn${activeCount > 0 ? " is-active" : ""}${className ? ` ${className}` : ""}`}
      aria-haspopup="dialog"
      aria-expanded={open}
      onClick={onClick}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" className="bq-icon" aria-hidden="true">
        <polygon points="3 4 21 4 14 12.5 14 20 10 20 10 12.5" />
      </svg>
      <span>{t("search.buscar.filters")}</span>
      {activeCount > 0 && <span className="bq-filter-btn-badge">{activeCount}</span>}
    </button>
  );
};

export default FilterButton;
